import { render, staticRenderFns } from "./_ResponsiveImage.vue?vue&type=template&id=4ae2989b&scoped=true&"
import script from "./_ResponsiveImage.vue?vue&type=script&lang=js&"
export * from "./_ResponsiveImage.vue?vue&type=script&lang=js&"
import style0 from "./_ResponsiveImage.vue?vue&type=style&index=0&id=4ae2989b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae2989b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VFlex,VIcon,VImg,VLayout})
